export default "__VITE_ASSET__Cy16pkxj__"